export function LogoMark({ size = 34, className = "" }) {
  return (
    <svg width={size} height={size} viewBox="0 0 64 64" className={className} aria-hidden="true">
      <rect width="64" height="64" fill="#050505" />
      <path d="M45 22 A16.4 16.4 0 1 0 45 42" fill="none" stroke="#CBA153" strokeWidth="3.5" strokeLinecap="square" />
      <line x1="31" y1="32" x2="46" y2="32" stroke="#CBA153" strokeWidth="3.5" />
    </svg>
  );
}

export function Logo({ dark = true }) {
  return (
    <span className="flex items-center gap-3" data-testid="brand-logo">
      <LogoMark />
      <span className={`font-serif text-xl tracking-wide ${dark ? "text-bone" : "text-black"}`}>
        Gurgaon <span className="font-mono text-[10px] uppercase tracking-[0.35em] text-gold align-middle ml-1">Estates</span>
      </span>
    </span>
  );
}
